"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInViewEffect = void 0;
var react_1 = require("react");
var react_intersection_observer_1 = require("react-intersection-observer");
var useInViewEffect = function (callback, options) {
  var opts = __assign({
    threshold: 0.5
  }, options || {});
  var _a = (0, react_intersection_observer_1.useInView)(opts),
    ref = _a.ref,
    inView = _a.inView;
  (0, react_1.useEffect)(function () {
    if (inView) {
      callback();
    }
  }, [inView]);
  return ref;
};
exports.useInViewEffect = useInViewEffect;